import { ref, computed } from "@vue/composition-api";
import { getCurrentDateISO8601 } from "@/shared.js";
import { section_Shared } from "./section_Shared";

function createNewItem(context) {
	let item = { date: getCurrentDateISO8601() };
	if (context == "timesheets") {
		item.timeHours = "0";
		item.timeMins = "0";
	}
	return item;
}

export function section_Dialog(context) {

	const { createDialogInfoObject } = section_Shared(context);

	let store = context.root.$store;    // do destructuring
	const showingDialog = ref(false);
	const objToDialog = ref(null);

	const showDialog = (context, item) => {
		let toggle = b => (showingDialog.value = b);
		objToDialog.value = createDialogInfoObject();
		objToDialog.value.close = () => toggle(false);
		objToDialog.value.inNewMode = !item;
		objToDialog.value.item = item ? { ...item } : createNewItem(context);
		objToDialog.value.update = item2 => {
			let objData = { context, item: { ...item2 } };
			if (item) store.dispatch("updateObjItem", objData);
			else store.dispatch("createObjItem", objData);
			toggle(false);
		};
		objToDialog.value.remove = item2 => {
			let objData = { context, item: { ...item2 } };
			store.dispatch("deleteObjItem", objData);
			toggle(false);
		};
		toggle(true); // open the dialog
	};

	return { showingDialog, objToDialog, showDialog };
}